import { LayoutItem, OfferImageLayoutEnum } from 'features/offers/types';
import _ from 'lodash';

const layouts: LayoutItem[] = [
  {
    imageLayout: OfferImageLayoutEnum.NoImage,
    top: false,
    bottom: false,
    left: false,
    right: false,
  },

  {
    imageLayout: OfferImageLayoutEnum.BigTopRight,
    top: {
      width: 940,
      height: 400,
    },
    left: false,
    right: {
      width: 300,
      height: 900,
    },
    bottom: {
      width: 620,
      height: 250,
    },
  },

  {
    imageLayout: OfferImageLayoutEnum.BigTopLeftRight,
    top: {
      width: 1100,
      height: 400,
    },
    left: {
      width: 220,
      height: 900,
    },
    right: {
      width: 220,
      height: 900,
    },
    bottom: {
      width: 620,
      height: 250,
    },
  },

  {
    imageLayout: OfferImageLayoutEnum.BigTop,
    top: {
      width: 1100,
      height: 400,
    },
    bottom: {
      width: 620,
      height: 250,
    },
    left: false,
    right: false,
  },

  {
    imageLayout: OfferImageLayoutEnum.SmallTop,
    top: {
      width: 940,
      height: 400,
    },
    bottom: {
      width: '100%',
      height: 150,
    },
    left: false,
    right: false,
  },

  {
    imageLayout: OfferImageLayoutEnum.BiggerTop,
    top: {
      width: '100%',
      height: 150,
    },
    bottom: {
      width: '100%',
      height: 150,
    },
    left: false,
    right: false,
  },
];

export const getImageLayout = (imageLayout: OfferImageLayoutEnum) =>
  _.find(layouts, (layout) => layout.imageLayout === imageLayout)!;

export default layouts;
